import { render, staticRenderFns } from "./product-search.component.vue?vue&type=template&id=6d86a2ed&scoped=true&"
import script from "./product-search.component.vue?vue&type=script&lang=ts&"
export * from "./product-search.component.vue?vue&type=script&lang=ts&"
import style0 from "./product-search.component.vue?vue&type=style&index=0&id=6d86a2ed&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d86a2ed",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VCheckbox,VCol,VDivider,VRow})
